import type { ReactNode } from 'react'
import { useRouter } from 'next/router'
import LoadingIcon from 'shared/icons/loading-icon'
import { InvalidInvitationLink } from '../components/invalid-invitation-link/invalid-invitation-link'
import { resolveInvitationErrorReason, useInvitationFlow } from './use-invitation-flow'

export const InvitationFlowGate = (): ReactNode => {
  const router = useRouter()
  const { confirmationToken, showInvalidInvitation } = router.query
  const communityPath = router.query.communityPath ?? ''
  const invitationToken = router.query.invitationToken ?? ''

  const { validity, showInvalidReason } = useInvitationFlow({
    communityPath,
    invitationToken,
    confirmationToken,
    showInvalidInvitation,
  })

  if (showInvalidReason) {
    return <InvalidInvitationLink reason={showInvalidReason} />
  }

  const errorReason = resolveInvitationErrorReason(validity.error)
  if (errorReason) {
    return <InvalidInvitationLink reason={errorReason} />
  }

  if (validity.isLoading || !validity.data) {
    return (
      <div className="flex justify-center p-10">
        <LoadingIcon />
      </div>
    )
  }

  const { status } = validity.data

  if (status === 'accepted' || status === 'pending') {
    return (
      <div className="flex justify-center p-10">
        <LoadingIcon />
      </div>
    )
  }

  if (status === 'expired') {
    return <InvalidInvitationLink reason="expired" />
  }

  if (status === 'canceled') {
    return <InvalidInvitationLink reason="canceled" />
  }

  return null
}
